import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ConversationListEntry } from '../../helpers/conversation-helper';
import styles from './conversation-list.module.css';

const LockIcon = () => (
  <svg className={styles.lock} viewBox='0 0 24 24' role='img' aria-label='somente leitura'>
    <path d='M17 9V7A5 5 0 0 0 7 7v2H5v13h14V9zM9 7a3 3 0 0 1 6 0v2H9zm8 13H7v-9h10z' />
  </svg>
);

const ConversationList: FC<{ entries: ConversationListEntry[] }> = ({ entries }) => (
  <ul className={styles.list} aria-label='Conversas'>
    {entries.map((entry) => (
      <li key={entry.id}>
        <Link
          to={entry.linkTo}
          className={`${styles.row} ${entry.unreadCount > 0 ? styles.unread : ''} ${entry.isReadOnly ? styles.readOnly : ''}`}
        >
          <span className={styles.line}>
            {entry.isReadOnly && <LockIcon />}
            <span className={styles.title}>{entry.title}</span>
            {entry.context && <span className={styles.context}>{entry.context}</span>}
            {entry.time && <time className={styles.time}>{entry.time}</time>}
          </span>
          <span className={styles.line}>
            <span className={`${styles.preview} ${entry.hasMessage ? '' : styles.empty}`}>{entry.preview}</span>
            {entry.unreadCount > 0 && (
              <span className={styles.badge} aria-label={`${entry.unreadCount} não lida${entry.unreadCount > 1 ? 's' : ''}`}>
                {entry.unreadCount}
              </span>
            )}
          </span>
        </Link>
      </li>
    ))}
  </ul>
);

export default ConversationList;
